import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_menu-project-concepts_test",
  "use": "svg_menu-project-concepts_test-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"svg_menu-project-concepts_test\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m3.707 4.707 3-3L5.293.293 3 2.586 1.707 1.293.293 2.707l2 2L3 5.414l.707-.707Zm0 6 3-3-1.414-1.414L3 8.586 1.707 7.293.293 8.707l2 2 .707.707.707-.707ZM13 4H8V2h5v2Zm-5 6h5V8H8v2Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol